import { createQueries } from '@mosaferati/api-client';
import { api } from './api.ts';

/** Query option factories bound to the app's API client. */
export const q = createQueries(api);
